import { useQuery } from '@tanstack/react-query';

import { api } from '@/api/client';
import type { SalesListResponse } from '@/api/sales';

export function useSalesList(page = 1, limit = 30) {
  return useQuery({
    queryKey: ['sales', 'list', { page, limit }],
    queryFn: () => api.get<SalesListResponse>('/api/sales', { page, limit }),
  });
}
